module.exports = __webpack_public_path__ + "static/media/02.45d4f681.mp3";